module.exports = __webpack_public_path__ + "static/media/ContractCopy@2x.40356df3.jpg";